import React, { useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import * as Yup from "yup";
import { addAndUpdateVersion } from '../../../../services/ProgramService';
import Swal from 'sweetalert2';
import PermissionsGate from '../../../../utils/permissionGate';
function VersionPageData(props) {
    const { versionData=[],loading=null,setLoading,setRefresh } = props;
    const {id, type} = useParams();
    const history = useHistory();
    const {search} = useLocation();
    const queryParams= new URLSearchParams(search);
    const versionId = queryParams.get("versionId");
    const programId = queryParams.get("programmeId");
    const [disabled, setDisabled]= useState(false)

    const formik = useFormik({
        enableReinitialize: type == 'create' ? false : true,
        initialValues: type == 'create' ? {
            name: "",
            notes: "",
            lock_version_settings: 0,
        } : {
            name: type === "clone" ? `${versionData?.name}\u00A0(Copy)` : (versionData?.name || ""),
            notes: versionData?.notes || "",
            lock_version_settings:versionData?.lock_version_settings || 0,
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Name is required"),
        }),
        onSubmit: async (values) => {
            setLoading(true);

            const payload = {
                ...values,
                pmc_id: programId,
            };

            if(type == "details" || type === "clone"){
                payload.id= versionId;

                if (type === "clone") {
                    payload.isDuplicate = true
                }
            }

            try {
                if (versionId) {
                    // update existing version
                    addAndUpdateVersion(payload)
                        .then(res => {
                            Swal.fire({
                                icon: "success",
                                title: "Success",
                                text: "Updated Successfully",
                            });
                            // redirect back to table after success
                            setDisabled(false);
                            setLoading(false);
                            
                            if (type === "clone") {
                                history.push(`/program-management-center/programmes/versions/table/${programId}`);
                            } else {
                                setRefresh(Date.now())
                            }
                        })
                        .catch(err => {
                            setDisabled(false);
                            setLoading(false);
                            Swal.fire({
                                icon: "error",
                                title: "Error",
                                text: err.response.data.message,
                            });
                        })
                } else {
                    // create new version
                    addAndUpdateVersion(payload)
                        .then(res => {
                            Swal.fire({
                                icon: "success",
                                title: "Success",
                                text: "Updated Successfully",
                            });
                            // redirect back to table after success
                            setDisabled(false);
                            setLoading(false);
                            history.push(`/program-management-center/programmes/versions/table/${programId}`);
                        })
                        .catch(err => {
                            setDisabled(false);
                            setLoading(false);
                            Swal.fire({
                                icon: "error",
                                title: "Error",
                                text: err.response.data.message,
                            });
                        })
                }


            } catch (error) {
                console.error("Error saving version:", error);
                setLoading(false); history.push(`/program-management-center/programmes/versions/table/${programId}`);
            }
        },
    });

    const handlereset = async () => {
        if(type === "create") {
            history.push(`/program-management-center/programmes/versions/table/${id || programId}`);
        }else{
            formik.resetForm();            
        }
    };

    return (
        <div className="card card-profile-info-card filter-table-bg">
            <div className="new-card-header">
                <div className="card-header pt-0">Version Information</div>
                <div className="card-body-inr card-body-info">
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group-blk mb-3">
                                    <label htmlFor="name">Name *</label>
                                    <input
                                        type="text"
                                        className={
                                            "form-control" +
                                            (formik.errors["name"] && formik.touched["name"]
                                                ? " is-invalid"
                                                : "")
                                        }
                                        name="name"
                                        id="name"
                                        title="Name"
                                        value={formik.values["name"]}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group-blk mb-3">
                                    <label htmlFor="notes">Notes</label>
                                    <textarea
                                        rows="3"
                                        className={
                                            "form-control" +
                                            (formik.errors["notes"] && formik.touched["notes"]
                                                ? " is-invalid"
                                                : "")
                                        }
                                        name="notes"
                                        id="notes"
                                        title="Notes"
                                        value={formik.values["notes"]}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-12">
                                <div className="card-header pt-0">
                                    <i
                                        className="fal fa-cog"
                                        style={{ color: "var(--topbar-color)" }}
                                    ></i>{" "}
                                    Version Settings
                                </div>
                            </div>
                            <div className="col-12">
                                <div
                                    className="d-flex"
                                    title="Lock Version Settings"
                                >
                                    <label className="mb-0">
                                       Lock Version Settings
                                        <i title='Lock Version Settings' className="fal fa-info-circle grade-icon pl-2"></i>
                                    </label>
                                    <PermissionsGate scopes={["pmcversionlocksettingedit"]} RenderError={() => 
                                        <div className="toggle-switch ml-2">
                                            <label className="switch">
                                                <input
                                                    type="checkbox"
                                                    checked={
                                                        formik.values.lock_version_settings == 1
                                                    }
                                                    disabled
                                                />
                                                <span className="slider slider-round"></span>
                                            </label>
                                        </div>
                                    }>
                                        <div className="toggle-switch ml-2">
                                            <label className="switch">
                                                <input
                                                    type="checkbox"
                                                    checked={
                                                        formik.values.lock_version_settings == 1
                                                    }
                                                    onChange={(e) => {
                                                        formik.setFieldValue(
                                                            "lock_version_settings",
                                                            e.target.checked ? 1 : 0
                                                        );
                                                    }}
                                                />
                                                <span className="slider slider-round"></span>
                                            </label>
                                        </div>
                                    </PermissionsGate>
                                </div>
                            </div>
                        </div>
                        <div className="form-group form-group-save-cancel mt-4">
                            <PermissionsGate scopes={[(versionId && type !== "clone") ? "pmcversionedit" : "pmcversionadd"]} errorProps={{ disabled: true }}>
                                <button
                                    className="btn btn-save btn-success"
                                    type="submit"
                                    title="Save"
                                    disabled={loading || disabled}
                                    onClick={formik.handleSubmit}
                                    >
                                    {loading ? (
                                        <i className="fas fa-cog fa-spin"></i>
                                    ) : (
                                        <i className="fal fa-save"></i>
                                    )}
                                    Save
                                </button>
                            </PermissionsGate>

                            <button
                                className="btn btn-close btn-danger"
                                type="button"
                                title="Cancel"
                                onClick={() => handlereset()}
                            >
                                <i className="fal fa-times"></i>Cancel
                            </button>
                        </div>
                        {/** map function to render all errors  */}
                        {Object.keys(formik.values).map((key) => {
                            if (formik.touched[key] && formik.errors[key]) {
                                return (
                                    <div className="invalid-feedback d-block" key={key}>
                                        {formik.errors[key]}
                                    </div>
                                );
                            }
                        })}
                    </form>
                </div>
            </div>
        </div>
    )
}

export default VersionPageData;
